module.exports = __webpack_public_path__ + "static/media/CIPRES_CAOBA.d7f6410f.jpg";